import { SET_NAME_MAX, SetNameSchema } from "@nexus/contracts";

/** Characters `SetNameSchema` rejects, matched as runs. */
const NOT_SET_NAME_SAFE = /[^a-zA-Z0-9 \-_.,&()']+/g;

/**
 * Default name for the new set on each tenant: the name of the set the
 * selected scripts came from. A name the set-name rule rejects is cleaned to
 * a safe variant (curly apostrophes become straight ones, other characters
 * become " - "); when that still fails, the caller's fallback is used. The
 * field stays editable either way.
 */
export function defaultBroadcastSetName(
  sourceSetName: string | null | undefined,
  fallback: string,
): string {
  const name = sourceSetName?.trim() ?? "";
  if (!name) return fallback;
  if (SetNameSchema.safeParse(name).success) return name;

  const safe = name
    .replace(/[\u2018\u2019\u00b4`]/g, "'")
    .replace(/[\u201c\u201d"]/g, "")
    .replace(NOT_SET_NAME_SAFE, " - ")
    .replace(/\s+/g, " ")
    .replace(/(?:\s*-\s*){2,}/g, " - ")
    .replace(/^[\s-]+|[\s-]+$/g, "")
    .slice(0, SET_NAME_MAX)
    .trim();
  return SetNameSchema.safeParse(safe).success ? safe : fallback;
}
